module.exports = __webpack_public_path__ + "static/media/camera-illustration.ca6b017d.png";